import React from 'react';
import styled from '@benzinga/themetron';
import classNames from 'classnames';
import { Button, ButtonVariant, ButtonLayout, ButtonSize } from '@benzinga/core-ui';

interface ActionButtonProps {
  attrs?: {
    className?: string;
    data?: {
      icon?: string;
      label: string;
      id?: string;
      link: string;
      size?: ButtonSize;
      style: string;
      target: string;
      type?: string;
      variant?: ButtonVariant;
      layout?: ButtonLayout;
      action_button_icon?: string;
      action_button_label: string;
      action_button_link: string;
      action_button_size?: ButtonSize;
      action_button_style?: string;
      action_button_target?: string;
      action_button_type?: string;
      action_button_variant?: ButtonVariant;
      action_button_layout?: ButtonLayout;
    };
  };
}

export const ActionButtonBlock: React.FC<ActionButtonProps> = ({ attrs }) => {
  const label = attrs?.data?.label ?? attrs?.data?.action_button_label;
  const link = attrs?.data?.link ?? attrs?.data?.action_button_link;
  const target = attrs?.data?.target ?? attrs?.data?.action_button_target;
  const style = attrs?.data?.style ?? attrs?.data?.action_button_style;
  const variant = attrs?.data?.variant ?? attrs?.data?.action_button_variant;
  const layout = attrs?.data?.layout ?? attrs?.data?.action_button_layout;
  const size = attrs?.data?.size ?? attrs?.data?.action_button_size;
  const className = classNames('block action-button-block', {
    [`${attrs?.className}`]: !!attrs?.className,
    [`${style}`]: !!style,
  });
  return (
    <ActionButtonWrapper className={className} href={link} target={target}>
      <Button id={attrs?.data?.id} layout={layout} size={size} variant={variant || 'primary'}>
        {label}
      </Button>
    </ActionButtonWrapper>
  );
};

export const ActionButtonWrapper = styled.a`
  &.action-button-block {
    display: block;
  }
`;
